import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const capterraTestimonialStyles = {
    testimonialSectionContainer: {
        borderRadius: '1rem',
        padding: '0 1rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: 0,
            borderRadius: '0.8rem 0.8rem 0 0',
        },
    },
    swipeViewContainer: {
        width: '100%',
    },
    headerContainer: {
        maxWidth: '72rem',
        margin: '0 auto',
        textAlign: 'center',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: '2.4rem',
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
    title: {
        margin: '0 auto 1.5rem',
    },
    testimonialGridContainer: {
        overflow: 'hidden',
        position: 'relative',
    },
    quoteAuthorSectionMargin: {
        marginTop: '2.5rem',
    },
    horizontalDivider: {
        display: 'block',
        border: `solid 1.5px ${colors.core.innovation}`,
        color: colors.core.innovation,
        width: '3.2rem',
        margin: '1.2rem 0',
    },
    chevronIcon: {
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        margin: '0 1.5rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
    grayIcon: {
        '& path': {
            fill: colors.core.smoke,
        },
    },
    cardBody: {
        minHeight: '43rem',
        minWidth: '22rem',
        border: `solid 1px ${colors.border.primary}`,
        borderRadius: '0.8rem',
        backgroundColor: colors.background.white,
        padding: '3.2rem',
        textAlign: 'left',
        '&:hover': {
            boxShadow: '0 0.4rem 1.2rem 0 rgba(0, 0, 0, 0.1)',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            maxWidth: '50rem',
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '2.4rem',
            height: 'auto',
        },
    },
    testimonialQuote: {
        width: '100%',
        marginTop: '1.2rem',
        maxHeight: '17rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '5',
        flex: '1',
        [`@media (max-width: ${breakpoints.md})`]: {
            fontSize: '1.8rem',
        },
    },
    cardLogo: {
        width: '12rem',
    },
    newTabIcon: {
        color: '#BEC7CF',
        height: '1.8rem',
        width: '1.8rem',
    },
    authorContainer: {
        width: '100%',
        [`@media (max-width: ${breakpoints.md})`]: {
            fontSize: '1.4rem',
        },
    },
    legalText: {
        marginTop: '1.2rem',
        fontSize: '1rem !important',
    },
} as const;
